import React from 'react';
import { Link } from "react-router";
import { Typography, Card, Grid } from '@mui/material';
import '../style.css';
import BookingRentalAgreementCheckbox from "./BookingRentalAgreementCheckbox";

interface BookingPaymentBeforeYouBookProps {
  rentalAgreementURL: string;
  hasAcceptedRentalAgreement: boolean;
  setHasAcceptedRentalAgreement: (value: boolean) => void;
  instantApproval: boolean;
  isBrokeredBooking: boolean;
}


const rentalAgreementSx = {
  backgroundColor: '#FFF6D8',
} as const;

const BookingPaymentBeforeYouBook = (props: BookingPaymentBeforeYouBookProps) => {
  const { rentalAgreementURL, hasAcceptedRentalAgreement, setHasAcceptedRentalAgreement, instantApproval, isBrokeredBooking } = props;

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHasAcceptedRentalAgreement(event.target.checked)
  }

  const cancellationText = (
    <>
      <span style={{ color: 'red' }}>⚠</span> <strong>Important: Same-Day Bookings Are Non-Refundable</strong> <br/>Customers can cancel for a full refund up to 24 hours before the start date of the booking. Bookings made for the same day — or any unused spaces — cannot be refunded. No Exceptions.
    </>
  );

  return (
    <Grid container direction='column' className='ss-booking-payment-byb-container'>
        <Typography variant='h6' color='textPrimary'>{ isBrokeredBooking ? 'BROKERED BOOKING' : 'Before You Book' }</Typography>
        <Card className="ss-byb-card" sx={{backgroundColor: '#F5F5F5'}}>
          <Typography variant={'h6'} color={'textPrimary'}>Cancellation Policy</Typography>
          <Typography variant='body2' className='ss-byb-card-desc' component="div">{cancellationText}</Typography>
          <br/>
          <Link to="/terms-of-use" target="_blank">
            <Typography variant='body2' color={'secondary'}>READ MORE</Typography>
          </Link>
        </Card>
        {
          instantApproval ?
            null
          : 
            <Card className="ss-byb-card" sx={rentalAgreementSx}>
              <Typography variant={'h6'}>Your Reservation</Typography>
              <Typography variant='body2' className='ss-byb-card-desc'>Your reservations won&#39;t be confirmed until the request is accepted. You will be notified by email and in your &quot;My Bookings&quot; page automatically whether your request is accepted within 30 minutes of submitting.</Typography>
            </Card>
        }
        {
          isBrokeredBooking ? null
          :
          <Grid item className='ss-byb-rental-agreement-container'>
            <BookingRentalAgreementCheckbox checked={hasAcceptedRentalAgreement} onChange={handleCheckBox} rentalAgreementUrl={rentalAgreementURL} name={"acceptedRentalAgreement"} />
          </Grid>
        }
    </Grid>
  );
};

export default BookingPaymentBeforeYouBook;
